var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "lucide-react";
import { Text, Badge, Button, Card, ButtonVariant } from "@merge-api/merge-javascript-shared";
import { LogoAvatar } from "./shared/LogoAvatar";
export var AuthenticateCallMessage = function (_a) {
    var connector = _a.connector, linkToken = _a.linkToken, onConnect = _a.onConnect, _b = _a.isConnected, isConnected = _b === void 0 ? false : _b;
    var handleConnect = function () {
        onConnect(linkToken);
    };
    return (_jsx("div", __assign({ className: "flex w-full justify-start" }, { children: _jsx(Card, __assign({ variant: "outline", className: "w-[65%] overflow-hidden" }, { children: _jsxs("div", __assign({ className: "flex flex-row items-center justify-between p-3" }, { children: [_jsxs("div", __assign({ className: "flex flex-row items-center gap-x-1.5" }, { children: [_jsx(LogoAvatar, { src: connector.logo_url, name: connector.name, size: 36 }), _jsx(Text, __assign({ variant: "h4" }, { children: connector.name })), isConnected && (_jsx(Badge, __assign({ color: "green", size: "sm" }, { children: "Success" })))] })), !isConnected && (_jsx(Button, __assign({ onClick: handleConnect, variant: ButtonVariant.SecondaryGray, size: "sm", leftIcon: _jsx(Link, { size: 12 }) }, { children: "Connect" })))] })) })) })));
};
